enum MINOR_LEGAL_CAPACITY {
  persCapacite05 = 'Mineur sous administration légale',
  persCapacite06 = 'Mineur sous tutelle',
  persCapacite07 = 'Mineur émancipé',
}

enum ADULT_LEGAL_CAPACITY_KO {
  persCapacite02 = 'Majeur sous tutelle',
  persCapacite04 = 'Majeur sous sauvegarde de justice',
  persCapacite08 = 'Majeur sous curatelle simple',
  persCapacite09 = 'Majeur sous curatelle renforcée',
  persCapacite10 = 'Majeur sous habilitation familiale',
  persCapacite11 = 'Majeur sous mandat de protection future',
  'Epargne Handicap' = 'Epargne handicap',
}

enum MAJOR_ADULT_LEGAL_CAPACITY {
  persCapacite01 = 'Majeur Capable',
}

enum LEGAL_CAPACITY_CATEGORY {
  adultOK = 'adultOK',
  adultKO = 'adultKO',
  minorKO = 'minorKO',
}

export { MINOR_LEGAL_CAPACITY, ADULT_LEGAL_CAPACITY_KO, MAJOR_ADULT_LEGAL_CAPACITY, LEGAL_CAPACITY_CATEGORY };
